var current,image,imgObj,imgSource,reader,file,text = "Enter Your Text",
    canvas,imgData,imgWidth,alignment,activeOb,target,fontSize,object,type,sCAle,
    textInput = document.getElementById('text_box'),effect,
    fill,fSize,fStyle,fWeight,tAlign,shade,f,action,left,top,oX,oY,sX,sY,
    undoButton = document.getElementById('undo'),
    redoButton = document.getElementById('redo'),
    Family = document.getElementById('fontFamily').value,
    bold = document.getElementById('bold'),
    italic = document.getElementById('italic'),
    mainWide = 700,//jQuery('.product__media-item.is-active>.product-media-container').innerWidth();
    mainHigh = 490,
    cWidth = 450,
    cHeight = 315;
var filters = ['grayscale', 'invert', 'remove-color', 'sepia', 'brownie',
               'brightness', 'contrast', 'vintage', 'technicolor', 'polaroid',
               'kodachrome', 'blackwhite'];

var diameter = +$('#diameter').val();
var kerning = +$('#kerning').val();
var flipped = $('#flip').is(':checked');

var id = 'myCanvas';
drawHistory.initCanvasState(id);
window[id] = new fabric.Canvas(id, {
  backgroundColor: "rgba(0,0,0,0)",
  top:600,
  width:cWidth,
  height:cHeight
});
canvas = window[id];
addModify(canvas);
// ✅ add guide AFTER canvas exists
// addGuideBox(canvas);

tooltip();
jQuery('.customColors').each(function(){
  colorBox = jQuery(this).attr('id');
  loadColorPicker(colorBox);
});

var shirtColorListName = ['Black', 'White', 'Heather Grey', 'Charcoal Grey', 'Knorr Green', 'Red', 'Navy Blue', 'Royal Blue', 'Light Purple', 'Sky Blue', 'Mustard',
                      'Beige', 'Light Pink', 'Maroon', 'Brown', 'Olive Green', 'Green', 'Yellow'];
var shirtColorListCode = [
  '#08090d', // Black
  '#e7e9ed', // White
  '#b5b8b5', // Heather Grey
  '#25262a', // Charcoal Grey
  '#527641', // Knorr Green (custom brand green)
  '#9a0b12', // Red
  '#0c1031', // Navy Blue
  '#072763', // Royal Blue
  '#85255c', // Light Purple (Thistle)
  '#8db3c8', // Sky Blue
  '#c58c2b', // Mustard
  '#a78b72', // Beige
  '#cf9ea7', // Light Pink
  '#4d071a', // Maroon
  '#964B00', // Brown
  '#BAB86C', // Olive Green
  '#008000', // Green
  '#FFFF00'  // Yellow
  ];

jQuery(document).on('click','.drawingButton .main_buttons',function(){
  
  var selectedColor = jQuery('input[name="Color"]:checked').val();
  var index = shirtColorListName.indexOf(selectedColor);
  
  if (index !== -1) {
      var colorCode = shirtColorListCode[index];
    canvas.setBackgroundColor(colorCode, canvas.renderAll.bind(canvas));
  } else {
  }
  
  canvasBlock(canvas);
  jQuery('.popupImg').show();
  jQuery('#tadaWidget').hide();
});

  
jQuery(document).on('click','.tool_option>.closePreview',function(){

  canvas.setBackgroundColor(null, canvas.renderAll.bind(canvas));
  canvas.discardActiveObject().renderAll();
  updatedPreivew(canvas);
  jQuery('.popupImg').hide();
});

jQuery('.popupBox').each(function(){
  jQuery(this).draggable({
    handle: "div.drag-me"
  });
});

jQuery('.popupBox input,.popupBox select,.popupBox textarea,.colorpicker,.colorpicker *').on('mousedown touchstart', function(e){
  e.stopPropagation();
});

jQuery(document).on('click','.tool_option>h4',function(){
  current = jQuery(this).next();
  jQuery('.popupBox').each(function(){
    jQuery(this).hide();
  });
  current.show();
});

jQuery(document).on('click','.closeTpop',function(e){
  e.stopPropagation();
  jQuery(this).parent().hide();
  canvas.discardActiveObject().renderAll();
});

jQuery(document).on('change','#uploadFile',function(event){
  file = event.target.files[0];
  reader = new FileReader();
  reader.onloadend = function(){
    imgSource = reader.result;
  };
  reader.readAsDataURL(file);
});

jQuery(document).on('change','#terms',function(){
  var term = jQuery(this).prop('checked');
  if(term){
    jQuery('#uploadNow').removeAttr('disabled');
  }else{
    jQuery('#uploadNow').attr('disabled','disabled');
  }
});

jQuery(document).on('click','#uploadNow',function(){
  reader = new FileReader();
  reader.onload = function (event){
    imgObj = new Image();
    imgObj.src = imgSource;
    imgObj.onload = function(){
      image = new fabric.Image(imgObj);
      image.set({
          originX:"center",
          originY:"center",
          scaleX: 1,
          scaleY: 1,
          left:cWidth / 2,
          top:cHeight / 2
      });
      image.scaleToWidth(cWidth/2);
      canvas.add(image).setActiveObject(image);
      canvas.renderAll();
    }
  }
  reader.readAsDataURL(file);
  jQuery('#uploadFile').val('');
  jQuery('#terms').prop('checked',false);
});

jQuery(document).on('click','#changeText',function(){
  addText();
});

jQuery(document).on('change','#clipart_category',function(){
  Showcontainer();
});

function tooltip(){
  var tipContent;
  jQuery('.toolTip').each(function(){
    tipContent = jQuery(this).attr('tooltip');
    jQuery(this).after('<div class="tooltipLabel">'+tipContent+'</div>');
  });
}
  
function Showcontainer(){
  var selectedOption = document.getElementById("clipart_category").value;
  jQuery('.drop_down_catgory>div').each(function(){
    jQuery(this).hide();
  });
  document.getElementById(selectedOption).style.display = "block";
}

var clonedObject = _.cloneDeep(object);
function cloneFabricObject(object) {
  return fabric.util.object.clone(object);
}

jQuery(document).on('click','.actionBtns>a',function(){
  if(jQuery(this).parent().hasClass('disabled')){
    return false
  }
  action = jQuery(this).attr('data-obj');
  activeOb = canvas.getActiveObject();
  if(activeOb){
    if(action === 'front'){
      canvas.bringToFront(activeOb);
    }
    if(action === 'flip'){
      activeOb.toggle('flipX');
    }if(action === 'alignH'){
      activeOb.left = cWidth/2;
    }if(action === 'alignV'){
      activeOb.top = cHeight/2;
    }if(action === 'moveL'){
      activeOb.left -= 2;
    }if(action === 'moveR'){
      activeOb.left += 2;
    }if(action === 'moveT'){
      activeOb.top -= 2;
    }if(action === 'moveB'){
      activeOb.top += 2;
    }if(action === 'trash'){
      canvas.remove(activeOb);
    }if(action === 'copy'){
      /*
      var cObject = fabric.util.object.clone(activeOb);
      canvas.add(cObject);
      canvas.setActiveObject(cObject);
      cObject.set('top', cObject.top+15);
      cObject.set('left', cObject.left+15);
      cObject.setCoords();
      */
      var clonedObject = cloneFabricObject(activeOb);
      canvas.discardActiveObject().renderAll();
      clonedObject.set({
        left: clonedObject.left + 15,
        top: clonedObject.top + 15
      });
      canvas.add(clonedObject).setActiveObject(clonedObject);
    }
    activeOb.setCoords();
    drawHistory.updateCanvasState(canvas,id);
  }
  canvas.renderAll();
});

function canvasMakeImg(zoom){
  newZoomLevel = zoom / cWidth;
  setZoomMask(newZoomLevel);
}

function canvasBlock(){
  if(window.innerHeight < window.innerWidth){
    zoom = window.innerHeight * .8;
    newZoomLevel = zoom / mainHigh;
  }else{
    zoom = window.innerWidth;
    newZoomLevel = 520 / mainWide;
  }
  setZoomMask(newZoomLevel);
}

function setZoomMask(newZoomLevel){
  canvas.setZoom(newZoomLevel);
  canvas.setDimensions({
    width: cWidth * newZoomLevel,
    height: cHeight * newZoomLevel
  });
  addGuideBox(canvas); // ✅ redraw guide after zoom
  canvas.renderAll();
  updatedPreivew();
}

function updatedPreivew(){

  object = canvas.getObjects();

  if(object.length > 0){
    jQuery('.main_buttons').text('Customize Design');
  }else{
    jQuery('.main_buttons').text('Edit Design');
  }
  
  imgData = canvas.toDataURL("image/png");
  
  zoom = jQuery('.product__media-item.is-active>.product-media-container').innerWidth();
  newZoomLevel = zoom / mainWide;
  imgWidth = '525' * newZoomLevel;
  jQuery('#drawingPreview').attr('src',imgData);
  jQuery('#drawingPreview').attr('style','width:'+imgWidth+'px');
  forceGuideOnTop(canvas); // ✅ KEEP IT ON TOP
}

jQuery(window).on('load',function(){
  canvasBlock();
  jQuery('#loader').hide();
});

jQuery(window).resize(function(){
   canvasBlock();
});



let guideBox = null;


function addGuideBox(canvas) {

  // remove existing guide safely
  if (guideBox) {
    canvas.remove(guideBox);
    guideBox = null;
  }

  guideBox = new fabric.Rect({
    left: cWidth / 2,
    top: cHeight / 2,
    originX: 'center',
    originY: 'center',
    width: 440,
    height: 305,
    fill: 'transparent',
    stroke: '#888',
    strokeWidth: 1,
    strokeDashArray: [6, 6],
    selectable: false,
    evented: false,
    objectCaching: false,
    hoverCursor: 'default'
  });

  guideBox.customType = 'guideBox';

  canvas.add(guideBox);
  forceGuideOnTop(canvas);
}



function forceGuideOnTop(canvas) {
  canvas.getObjects().forEach(obj => {
    if (obj.customType === 'guideBox') {
      canvas.bringToFront(obj);
    }
  });
  canvas.renderAll();
}






function renderIcon(icon) {
  return function (ctx, left, top, styleOverride, fabricObject) {
    const size = this.cornerSize;
    ctx.save();
    ctx.translate(left, top);
    ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
    ctx.drawImage(icon, -size / 2, -size / 2, size, size);
    ctx.restore();
  };
}

var filteringBox = document.getElementById('imgFilterPop');

function addModify(){
  f = fabric.Image.filters;
  fabric.Object.prototype.padding = 5;
  fabric.Object.prototype.transparentCorners = false;
  fabric.textureSize = 75497472;

  canvas.renderOnAddRemove = false;
  
  canvas.on('selection:cleared', function(e){
    object = e.target;
    jQuery('.actionBtns').addClass('disabled');
    fabric.util.toArray(filteringBox.getElementsByTagName('input')).forEach(function(el){ el.disabled = true; });
    jQuery('.thePop').each(function(){
      jQuery(this).find('.colorOFF').trigger('click');
      jQuery(this).hide();
    });
  });
  
  canvas.on('object:removed',function(e){
    object = e.target;
  });
  
  canvas.on('object:added', function(e){
    object = e.target;
    drawHistory.updateCanvasState(canvas,id);
    undoButton.removeAttribute("disabled");
    addControls(object);
    forceGuideOnTop(canvas);
  });
  
  canvas.on('object:modified', function(e){
    object = e.target;
    drawHistory.updateCanvasState(canvas,id);
    forceGuideOnTop(canvas);
    canvas.renderAll();
  });
  
  canvas.on('selection:created', function(e){
    object = canvas.getActiveObject();
    selectedObj(object);
    forceGuideOnTop(canvas);
  });
  
  canvas.on('selection:updated', function(e){
    object = canvas.getActiveObject();
    selectedObj(object);
    forceGuideOnTop(canvas);
  });
  
  canvas.on('object:scaling', function(e){
    canvas.renderAll();
    forceGuideOnTop(canvas);
  });
}

function selectedObj(object){
  jQuery('.thePop').each(function(){
    jQuery(this).hide();
  });
  jQuery('.actionBtns').removeClass('disabled');
  type = object.type;
  if(type == 'text'){
    jQuery('#italic').prop('checked',false);
    jQuery('#bold').prop('checked',false);

    
    fill = object.fill;
    Family = object.fontFamily;
    fSize = object.fontSize;
    fStyle = object.fontStyle;
    fWeight = object.fontWeight;
    text = object.text;
    tAlign = object.textAlign;

    jQuery('#textColor .currentColor').val(fill);
    jQuery('#textColor .currentColor+.colorBox').css('backgroundColor',fill);
    jQuery('#fontFamily').val(Family);
    jQuery('#fSize').val(fSize);
    jQuery('input[name="text-align"][value="'+tAlign+'"]').prop('checked',true);
    
    if(fStyle == 'italic'){
      jQuery('#italic').prop('checked',true);
    }
    if(fWeight == 'bold'){
      jQuery('#bold').prop('checked',true);
    }
    
    textInput.value = text;
    
    jQuery('#textPop').show();
  }
  if(type == 'path'){
    var isColor = /[0-9A-Fa-f]{6}/g;
    fill = object.stroke;
    shade = object.shadow.color;
    if(isColor.test(fill)){
      jQuery('#line-color .currentColor').val(fill);
      jQuery('#line-color .currentColor+.colorBox').css('backgroundColor',fill);
      jQuery('#shade-color .currentColor').val(shade);
      jQuery('#shade-color .currentColor+.colorBox').css('backgroundColor',shade);
      jQuery('#drawing-colors').show();
    }
  }
  if(type == 'image'){
    fabric.textureSize = 75497472;
    fabric.util.toArray(filteringBox.getElementsByTagName('input')).forEach(function(el){
      el.disabled = false;
    });
    for (var i = 0; i < filters.length; i++) {
      if($(filters[i]) && ($(filters[i]).checked = !!object.filters[i])){
        $('#'+filters[i]).prop('checked',true);
      }else{
        $('#'+filters[i]).prop('checked',false);
      }
      console.log($(filters[i]) && ($(filters[i]).checked = !!object.filters[i]));
    };
    jQuery('#imgFilterPop').show();
  }
  //console.log(object);
}

jQuery(document).on('change','#effect',function(){
  effect = jQuery(this).val();
  object = canvas.getActiveObject();
  
  fill = object.fill;
  Family = object.fontFamily;
  fSize = object.fontSize;
  fStyle = object.fontStyle;
  fWeight = object.fontWeight;
  text = object.text;
  left = object.top;
  top = object.left;
  oX = object.originX;
  oY = object.originY;
  sX = object.scaleX;
  sY = object.scaleY;
  
  if(effect == 'curved'){
    const curvedText = new fabric.CurvedText(text, {
      left: cWidth / 2,
      top: cHeight / 2,
      fill: fill,
      fontFamily: Family,
      fontSize: fSize,
      fontStyle: fStyle,
      fontWeight: fWeight,
      originX: oX,
      originY: oY,
      radius: 150,
      startAngle: -90,
      spacing: 15,
      clockwise: true,
    });
  
    canvas.add(curvedText).setActiveObject(curvedText).renderAll();
  }
});

function addControls(object){

  var iconTL = document.createElement("img"),
      iconBR = document.createElement("img"),
      iconRo = document.createElement("img");

  iconTL.src = trashIcon;
  iconBR.src = resizeIcon;
  iconRo.src = rotateIcon;

  object.set({
    transparentCorners: false,
    borderColor: '#ddd',
    borderDashArray: [6,2],
    cornerStyle: 'circle',
    cornerColor: '#fff',
    objectCaching: false,
    _controlsVisibility: {
      tr: false,
      tl: true,   // trash
      bl: false,
      br: true,   // resize
      mb: false,
      ml: false,
      mr: false,
      mt: false,
      mtr: true   // 🔥 ENABLE ROTATE SLOT
    }
  });

  // 🗑️ DELETE
  iconTL.onload = function() {
    fabric.Object.prototype.controls.tl = new fabric.Control({
      x: -0.5,
      y: -0.5,
      cursorStyle: "pointer",
      mouseUpHandler: deleteHandler,
      render: renderIcon(iconTL),
      cornerSize: 18
    });
  };

  // 🔲 RESIZE
  iconBR.onload = function() {
    fabric.Object.prototype.controls.br = new fabric.Control({
      x: 0.5,
      y: 0.5,
      cursorStyle: "se-resize",
      actionHandler: fabric.controlsUtils.scalingEqually,
      render: renderIcon(iconBR),
      cornerSize: 18
    });
  };

  // 🔄 ROTATE
  iconRo.onload = function() {
    fabric.Object.prototype.controls.mtr = new fabric.Control({
      x: 0,
      y: -0.5,
      offsetY: -30,              // distance from object
      cursorStyle: "crosshair",
      actionHandler: fabric.controlsUtils.rotationWithSnapping,
      render: renderIcon(iconRo),
      cornerSize: 18
    });
  };
}

  
function addText(){
  var textObject = new fabric.Text('Enter Your Text',{
    left:cWidth / 2,
    top:cHeight / 2,
    originX:"center",
    originY:"center",
    scaleX: 1,
    scaleY: 1,
    fill: '#000',
    fontSize: 20,
    fontFamily: "'Arial',sans-serif",
    fontWeight: 'normal',
    textAlign: 'center'
  });
  canvas.add(textObject).setActiveObject(textObject).renderAll();
}

textInput.addEventListener('input', function(){
  activeOb = canvas.getActiveObject();
  
  if(activeOb && activeOb.type === 'text'){
    activeOb.set({ text: this.value });
    canvas.renderAll();
    drawHistory.updateCanvasState(canvas,id);
  }
});

bold.addEventListener('change',function(){
  dtEditText('bold');
});

italic.addEventListener('change',function(){
  dtEditText('italic');
});

function dtEditText(action){
  var o,t,
      a = action;
  o = canvas.getActiveObject();
  sCAle = o.scaleX;
  if(o){
    t = o.get('type');
  }
  if(o && t === 'text' || t === 'text-curved' || type === 'curvedText'){
    switch(a){
      case 'bold':
        var isBold = dtGetStyle(o, 'fontWeight') === 'bold';
        dtSetStyle(o, 'fontWeight', isBold ? '' : 'bold');
        break;
        
      case 'italic':
        var isItalic = dtGetStyle(o, 'fontStyle') === 'italic';
        dtSetStyle(o, 'fontStyle', isItalic ? '' : 'italic');
        break;
    }
  }
  o.scaleX = .5;
  o.setCoords();
  canvas.renderAll();
  o.scaleX = sCAle;
  o.setCoords();
  canvas.renderAll();
  drawHistory.updateCanvasState(canvas,id);
}

function dtGetStyle(object,styleName){
  return object[styleName];
}

function dtSetStyle(object,styleName,value){
  object.set(styleName,value);
}

function loadColorPicker(colorBox){
  jQuery('#'+colorBox).colorpicker({
    inline: true,
    container: true,
    extensions:[{
      name: 'swatches',
      options:{
        colors:{
          'tetrad1': 'transparent',
          'tetrad2': '#e30405',
          'tetrad3': '#197b30',
          'tetrad4': '#0054a5',
          'tetrad5': '#ffcc00',
          'tetrad6': '#f6ebbe',
          'tetrad7': '#ffea00',
          'tetrad8': '#f8931d',
          'tetrad9': '#f499c2',
          'tetrad10': '#959595',
          'tetrad11': '#fef335',
          'tetrad12': '#a0400d',
          'tetrad13': '#000000',
          'tetrad14': '#604973',
          'tetrad15': '#afe8fc',
          'tetrad16': '#fffafa',
          'tetrad17': '#bc8cbe',
          'tetrad18': '#ff69b4',
          'tetrad19': '#93278f',
          'tetrad20': '#009987',
          'tetrad21': '#0af447',
          'tetrad22': '#00008b',
          'tetrad23': '#006400'
        },
        namesAsValues: false
      }
    }],
    template: '<div class="colorpicker">' +
      '<div class="colorpicker-saturation"><i class="colorpicker-guide"></i></div>' +
      '<div class="colorpicker-hue"><i class="colorpicker-guide"></i></div>' +
      '<div class="colorpicker-alpha">' +
      '   <div class="colorpicker-alpha-color"></div>' +
      '   <i class="colorpicker-guide"></i>' +
      '</div>' +
      '<div class="colorpicker-bar">' +
      '   <a href="javascript:void(0);" class="button btn-block colorOFF">Ok</a>'+
      '   <div class="ctn-icon-eyedropper dropper-eyedrop"><svg class="icon icon-eyedropper" viewBox="0 0 16 16">'+
      '   <path d="M13.354.646a1.207 1.207 0 0 0-1.708 0L8.5 3.793l-.646-.647a.5.5 0 1 0-.708.708L8.293 5l-7.147 7.146A.5.5 0 0 0 1 12.5v1.793l-.854.853a.5.5'+
      '   0 1 0 .708.707L1.707 15H3.5a.5.5 0 0 0 .354-.146L11 7.707l1.146 1.147a.5.5 0 0 0 .708-.708l-.647-.646 3.147-3.146a1.207'+
      '   1.207 0 0 0 0-1.708zM2 12.707l7-7L10.293 7l-7 7H2z"/></svg></div>'+
      '</div>' +
      '</div>'
  }).on('colorpickerCreate', function(){
    var colorBox = jQuery(this);
    setTimeout(function(){
      var colorID = colorBox.attr('id'),
        active = colorBox.find('.currentColor'),
        activeCOLOR = active.attr('value');
      colorBox.find('.colorBox').attr('style','background:'+activeCOLOR+';');
    },200);
  }).on('colorpickerChange', function(){
    var colorBox = jQuery(this);
    setTimeout(function(){
      var colorID = colorBox.attr('id'),
        active = colorBox.find('.currentColor'),
        activeCOLOR = active.attr('value');
      colorBox.find('.colorBox').attr('style','background:'+activeCOLOR+';');
      colorBox.attr('data-color',activeCOLOR);
      updateBrush();
      activeOb = canvas.getActiveObject();
          if(activeOb){
            sCAle = activeOb.scaleX;
            if(colorID === 'textColor'){
              activeOb.set('fill',activeCOLOR);
            }
            if(colorID === 'line-color'){
                activeOb.stroke = activeCOLOR;
            }
            if(colorID === 'shade-color'){
              activeOb.shadow.color = activeCOLOR;
            }
            activeOb.scaleX = .5;
            activeOb.setCoords();
            canvas.renderAll();
            activeOb.scaleX = sCAle;
            activeOb.setCoords();
            canvas.renderAll();
            drawHistory.updateCanvasState(canvas,id);
        }
    },200);
  });
  jQuery(document).on('click','.colorBox',function(){
    jQuery('.colorBox').each(function(){
      jQuery(this).next().hide();
    });
    jQuery(this).next().show();
  });
  jQuery(document).on('click','.colorOFF',function(){
    var parENt = jQuery(this).parent().parent(),
        toolBarBox = parENt.parent().parent().parent().attr('id');
    if(toolBarBox === 'labelBase'){
      parENt.parent().parent().parent().parent().removeClass('active');
    }else{
      parENt.hide();
    }
  });
}

jQuery(document).on('click','.dropper-eyedrop',function(){
  const eyeDropper = new EyeDropper();
  eyeDropper.open().then(result => {
    jQuery(this).parent().parent().parent().colorpicker('setValue', result.sRGBHex);
  }).catch(e => {
    console.error(e);
  });
});

document.getElementById('fontFamily').addEventListener('change', function(){
  activeOb = canvas.getActiveObject();
  if (activeOb && activeOb.type === 'text'){
    activeOb.set({ fontFamily: this.value });
    canvas.renderAll();
    drawHistory.updateCanvasState(canvas,id);
  }
});

jQuery(document).on('change','#fSize',function(){
  fontSize = jQuery(this).val();
  activeOb = canvas.getActiveObject();
  if(activeOb){
    sCAle = activeOb.scaleX;
    type = activeOb.get('type');
    if(type === 'text' || type === 'curvedText'){
      activeOb.set('fontSize',fontSize);
    }
    activeOb.scaleX = .5;
    activeOb.setCoords();
    canvas.renderAll();
    activeOb.scaleX = sCAle;
    activeOb.setCoords();
    canvas.renderAll();
    drawHistory.updateCanvasState(canvas,id);
  }
});

jQuery(document).on('change','input[name="text-align"]',function(){
  alignment = jQuery(this).val();
  activeOb = canvas.getActiveObject();
  if(activeOb){
    type = activeOb.get('type');
    if(type === 'text' || type === 'curvedText'){
      activeOb.set('textAlign',alignment);
    }
    activeOb.setCoords();
    canvas.renderAll();
    drawHistory.updateCanvasState(canvas,id);
  }
});

jQuery(document).on('click','.side-02 .popupBox .drop_down_catgory img',function(){
  current = jQuery(this);
  addImageToCanvas(current);
});

function addImageToCanvas(clickedImage){
  var imgSrc = clickedImage.attr('data-src');
  imgObj = new Image();
  imgObj.src = imgSrc;
  imgObj.onload = function(){
    image = new fabric.Image(imgObj);
    image.set({
        originX:"center",
        originY:"center",
        scaleX: 1,
        scaleY: 1,
        left:cWidth / 2,
        top:cHeight / 2
    });
    image.scaleToWidth(cWidth/2);
    canvas.add(image).setActiveObject(image);
    canvas.renderAll();
  }
}

function deleteHandler(eventData,transform){
  var target = transform.target;
  activeOb = canvas.getActiveObject();
  canvas.remove(activeOb);
  canvas.renderAll();
}
  
jQuery(document).on('click','#addThumb',function(){
  var size = 4000;//jQuery('.product__media-outer').innerWidth('4000');
  jQuery('#loader').show();
   canvasMakeImg(size);
  jQuery('.canvas_div').hide();
  // 🔥 REMOVE GUIDE (OLD STYLE)
  if (guideBox) {
    canvas.remove(guideBox);
  }
  imgData = canvas.toDataURL("image/png");
  fetch('//technology-architects.com/tasweer-modules/save_image.php',{
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      imageData: imgData
    })
  })
  .then(response => response.text())
  .then(data => {
    console.log(data);
    jQuery('.product__media-outer').innerWidth('248');
    
    jQuery('#previewImg').val(data);
    jQuery('.product-form__buttons .product-form__submit').trigger('click');
    
    canvasBlock();
    jQuery('.canvas_div').show();
    jQuery('#loader').hide();
  })
  .catch(error => console.error('Error uploading images:', error));
});

jQuery(document).on('click','#addT_Shirt',function(){
  var temp = 250, orig = 4000;
  jQuery('#loader').show();
  jQuery('.canvas_div').hide();

  canvasMakeImg(temp);
  loadWaterMark();

  if (guideBox) canvas.remove(guideBox);

  const tempImageBase64 = canvas.toDataURL({
    format: 'png',
    quality: 1.0
  });

  canvasMakeImg(orig);
    if (guideBox) canvas.remove(guideBox);
  removeWaterMark();
  const originalImageBase64 = canvas.toDataURL({
    format: 'png',
    quality: 1.0
  });
  frameColor = jQuery('.frameColorBox').val();
  jQuery('.product__media-outer').innerWidth('248');
  canvasBlock();
  console.log(tempImageBase64);
  fetch('//technology-architects.com/tasweer-modules/save_order.php',{
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      temp_image: tempImageBase64,
      original_image: originalImageBase64
    })
  })
  .then(response => response.json())
  .then(data => {
    console.log(data);
    var previewId = data[0],
        extraImg1 = data[1];
    jQuery('#previewImg').val(previewId);
    jQuery('#preExtraImg').val(extraImg1);
    jQuery('#selected_frameColor').val(frameColor);
    //console.log('Server response:', data);
    jQuery('.product-form__buttons .product-form__submit').trigger('click');
  })
  .catch(error => console.error('Error uploading images:', error));

  
});

var loadedObject;
function loadWaterMark(){
  var elem = document.getElementById('wm_collage'),
      svgStr = elem.innerHTML;
  fabric.loadSVGFromString(svgStr, function(objects,options){
    loadedObject = fabric.util.groupSVGElements(objects, options);
    loadedObject.scaleToWidth(cWidth);
    loadedObject.set({
      left: cWidth / 2,
      top: cHeight / 2,
      originX: 'center',
      originY: 'center',
      objectCaching: false,
      selectable: false
    });
    canvas.add(loadedObject);
    loadedObject.setCoords();
    canvas.renderAll();
  });
}

function removeWaterMark(){
  canvas.remove(loadedObject).renderAll();
}

jQuery(document).on('click','#addDrawing',function(){
  canvas.set({
    isDrawingMode: true
  }).discardActiveObject().renderAll();
  updateBrush();
  jQuery('#drawing-mode-options').show();
});

jQuery(document).on('click','#clear-canvas',function(){
  canvas.clear().renderAll();
});

jQuery(document).on('click','#closeDrawing',function(){
  canvas.set({
    isDrawingMode: false
  }).renderAll();
});

function updateBrush(){
  current = jQuery('#drawing-mode-selector').val();
  var select = document.getElementById('drawing-mode-selector');
  var items = select.getElementsByTagName('option');
  var index = Math.floor(Math.random() * items.length);
  select.selectedIndex = index;
  setTimeout(function(){
    jQuery('#drawing-mode-selector').val(current).change();
  },50)
}

(function(){
  var $ = function(id){return document.getElementById(id)};
  
  fabric.Object.prototype.transparentCorners = false;

  var drawingModeEl = $('drawing-mode'),
      drawingOptionsEl = $('drawing-mode-options'),
      drawingColorEl = $('drawing-color'),
      drawingShadowColorEl = $('drawing-shadow-color'),
      drawingLineWidthEl = $('drawing-line-width'),
      drawingShadowWidth = $('drawing-shadow-width'),
      drawingShadowOffset = $('drawing-shadow-offset'),
      dLW = $('dLW'),
      dSw = $('dSw'),
      dSo = $('dSo');

  drawingModeEl.onclick = function() {
    canvas.isDrawingMode = !canvas.isDrawingMode;
    if (canvas.isDrawingMode) {
      drawingModeEl.innerHTML = 'Cancel drawing mode';
      drawingOptionsEl.style.display = '';
    }
    else {
      drawingModeEl.innerHTML = 'Cancel drawing mode';
      drawingOptionsEl.style.display = 'none';
    }
  };

  if (fabric.PatternBrush) {
    var vLinePatternBrush = new fabric.PatternBrush(canvas);
    vLinePatternBrush.getPatternSrc = function() {

      var patternCanvas = fabric.document.createElement('canvas');
      patternCanvas.width = patternCanvas.height = 10;
      var ctx = patternCanvas.getContext('2d');

      ctx.strokeStyle = this.color;//getAttribute('data-color');
      ctx.lineWidth = 5;
      ctx.beginPath();
      ctx.moveTo(0, 5);
      ctx.lineTo(10, 5);
      ctx.closePath();
      ctx.stroke();

      return patternCanvas;
    };

    var hLinePatternBrush = new fabric.PatternBrush(canvas);
    hLinePatternBrush.getPatternSrc = function() {

      var patternCanvas = fabric.document.createElement('canvas');
      patternCanvas.width = patternCanvas.height = 10;
      var ctx = patternCanvas.getContext('2d');

      ctx.strokeStyle = this.color;//getAttribute('data-color');
      ctx.lineWidth = 5;
      ctx.beginPath();
      ctx.moveTo(5, 0);
      ctx.lineTo(5, 10);
      ctx.closePath();
      ctx.stroke();

      return patternCanvas;
    };

    var squarePatternBrush = new fabric.PatternBrush(canvas);
    squarePatternBrush.getPatternSrc = function() {

      var squareWidth = 10, squareDistance = 2;

      var patternCanvas = fabric.document.createElement('canvas');
      patternCanvas.width = patternCanvas.height = squareWidth + squareDistance;
      var ctx = patternCanvas.getContext('2d');

      ctx.fillStyle = this.color;//getAttribute('data-color');
      ctx.fillRect(0, 0, squareWidth, squareWidth);

      return patternCanvas;
    };

    var diamondPatternBrush = new fabric.PatternBrush(canvas);
    diamondPatternBrush.getPatternSrc = function() {

      var squareWidth = 10, squareDistance = 5;
      var patternCanvas = fabric.document.createElement('canvas');
      var rect = new fabric.Rect({
        width: squareWidth,
        height: squareWidth,
        angle: 45,
        fill: this.color//getAttribute('data-color')
      });

      var canvasWidth = rect.getBoundingRect().width;

      patternCanvas.width = patternCanvas.height = canvasWidth + squareDistance;
      rect.set({ left: canvasWidth / 2, top: canvasWidth / 2 });

      var ctx = patternCanvas.getContext('2d');
      rect.render(ctx);

      return patternCanvas;
    };

    var img = new Image();
    img.src = honeyImg;

    var texturePatternBrush = new fabric.PatternBrush(canvas);
    texturePatternBrush.source = img;
  }

  $('drawing-mode-selector').onchange = function(){
    if (this.value === 'hline') {
      canvas.freeDrawingBrush = vLinePatternBrush;
    }
    else if (this.value === 'vline') {
      canvas.freeDrawingBrush = hLinePatternBrush;
    }
    else if (this.value === 'square') {
      canvas.freeDrawingBrush = squarePatternBrush;
    }
    else if (this.value === 'diamond') {
      canvas.freeDrawingBrush = diamondPatternBrush;
    }
    else if (this.value === 'texture') {
      canvas.freeDrawingBrush = texturePatternBrush;
    }
    else {
      canvas.freeDrawingBrush = new fabric[this.value + 'Brush'](canvas);
    }

    if(canvas.freeDrawingBrush){
      var brush = canvas.freeDrawingBrush;
      brush.color = drawingColorEl.getAttribute('data-color');
      if (brush.getPatternSrc) {
        brush.source = brush.getPatternSrc.call(brush);
      }
      brush.width = parseInt(drawingLineWidthEl.value, 10) || 1;
      brush.shadow = new fabric.Shadow({
        blur: parseInt(drawingShadowWidth.value, 10) || 0,
        offsetX: 0,
        offsetY: 0,
        affectStroke: true,
        color: drawingShadowColorEl.getAttribute('data-color'),
      });
    }
  };

  drawingColorEl.onchange = function() {
    var brush = canvas.freeDrawingBrush;
    brush.color = this.getAttribute('data-color');
    if (brush.getPatternSrc) {
      brush.source = brush.getPatternSrc.call(brush);
    }
  };
  drawingShadowColorEl.onchange = function() {
    canvas.freeDrawingBrush.shadow.color = this.value;
  };
  drawingLineWidthEl.onchange = function() {
    canvas.freeDrawingBrush.width = parseInt(this.value, 10) || 1;
    dLW.innerHTML = this.value;
    updateBrush();
  };
  drawingShadowWidth.onchange = function() {
    canvas.freeDrawingBrush.shadow.blur = parseInt(this.value, 10) || 0;
    dSw.innerHTML = this.value;
  };
  drawingShadowOffset.onchange = function() {
    canvas.freeDrawingBrush.shadow.offsetX = parseInt(this.value, 10) || 0;
    canvas.freeDrawingBrush.shadow.offsetY = parseInt(this.value, 10) || 0;
    dSo.innerHTML = this.value;
  };
  if (canvas.freeDrawingBrush) {
    canvas.freeDrawingBrush.color = drawingColorEl.getAttribute('data-color');
    //canvas.freeDrawingBrush.source = canvas.freeDrawingBrush.getPatternSrc.call(this);
    canvas.freeDrawingBrush.width = parseInt(drawingLineWidthEl.value, 10) || 1;
    canvas.freeDrawingBrush.shadow = new fabric.Shadow({
      blur: parseInt(drawingShadowWidth.value, 10) || 0,
      offsetX: 0,
      offsetY: 0,
      affectStroke: true,
      color: drawingShadowColorEl.getAttribute('data-color')//.value,
    });
  }
})();

(function() {
  // manually initialize 2 filter backend to give ability to switch:
  var webglBackend;
  try {
    webglBackend = new fabric.WebglFilterBackend();
  } catch (e) {
    console.log(e)
  }
  var canvas2dBackend = new fabric.Canvas2dFilterBackend();

  fabric.filterBackend = fabric.initFilterBackend();
  fabric.Object.prototype.transparentCorners = false;
  var $ = function(id){return document.getElementById(id)};

  function applyFilter(index, filter) {
    var obj = canvas.getActiveObject();
    obj.filters[index] = filter;
    obj.applyFilters();
    canvas.renderAll();
    drawHistory.updateCanvasState(canvas,id);
  }

  function getFilter(index) {
    var obj = canvas.getActiveObject();
    return obj.filters[index];
  }

  function applyFilterValue(index, prop, value) {
    var obj = canvas.getActiveObject();
    if (obj.filters[index]) {
      obj.filters[index][prop] = value;
      obj.applyFilters();
      canvas.renderAll();
    }
  }
  
  var indexF;
  $('grayscale').onclick = function() {
    applyFilter(0, this.checked && new f.Grayscale());
  };
  $('average').onclick = function() {
    applyFilterValue(0, 'mode', 'average');
  };
  $('luminosity').onclick = function() {
    applyFilterValue(0, 'mode', 'luminosity');
  };
  $('lightness').onclick = function() {
    applyFilterValue(0, 'mode', 'lightness');
  };
  $('invert').onclick = function() {
    applyFilter(1, this.checked && new f.Invert());
  };
  $('remove-color').onclick = function () {
    applyFilter(2, this.checked && new f.RemoveColor({
      distance: $('remove-color-distance').value,
      color: $('remove-color-color').value,
    }));
  };
  $('remove-color-color').onchange = function() {
    applyFilterValue(2, 'color', this.value);
  };
  $('remove-color-distance').oninput = function() {
    applyFilterValue(2, 'distance', this.value);
  };
  $('sepia').onclick = function() {
    applyFilter(3, this.checked && new f.Sepia());
  };
  $('brownie').onclick = function() {
    applyFilter(4, this.checked && new f.Brownie());
  };
  $('brightness').onclick = function () {
    applyFilter(5, this.checked && new f.Brightness({
      brightness: parseFloat($('brightness-value').value)
    }));
  };
  $('brightness-value').oninput = function() {
    applyFilterValue(5, 'brightness', parseFloat(this.value));
  };
  $('vintage').onclick = function() {
    applyFilter(7, this.checked && new f.Vintage());
  };
  $('technicolor').onclick = function() {
    applyFilter(8, this.checked && new f.Technicolor());
  };
  $('polaroid').onclick = function() {
    applyFilter(9, this.checked && new f.Polaroid());
  };
  $('kodachrome').onclick = function() {
    applyFilter(10, this.checked && new f.Kodachrome());
  };
  $('blackwhite').onclick = function() {
    applyFilter(11, this.checked && new f.BlackWhite());
  };
})();